// Singleton store for the active viewshed computation result.
// The Viewshed component writes here; TerrainOverlay reads here during tile rendering.
// Subscribers (e.g. TerrainAnalysis) are notified so they can re-trigger tile re-renders.

const _listeners = new Set()
let _data = null

export const viewshedStore = {
  get data() { return _data },

  set(data) {
    _data = data
    _listeners.forEach(fn => fn())
  },

  clear() {
    _data = null
    _listeners.forEach(fn => fn())
  },

  // Returns an unsubscribe function.
  onChange(fn) {
    _listeners.add(fn)
    return () => _listeners.delete(fn)
  },
}
